import axios from "axios";
import i18n from "@/locales/i18n";

const API_URL = "https://prokuroriaapi.cmdsoftwares.com/api/v1/";

//const API_URL="https://localhost:7131/api/v1/"

import { getWebPagesId } from "@/utils/webPage";


class DocumentService {
  async getDocumentTypeCounts() {
    const webPage = getWebPagesId();

    return await axios

      .get(
        `${API_URL}dashboard/document/type-count/${webPage}/${
          i18n.global.locale || "AL"
        }`
      )
      .then((response) => response.data);
  }

  async getDocuments(doc) {
    const webPage = getWebPagesId();

    const requestBody = {
      prokuroriaId: webPage || doc.prokuroriaId || null,
      documentTypeId: doc.documentTypeId || null,
      language: i18n.global.locale || "AL",
      categoriesIds: doc.CategoriesIds?.length ? doc.CategoriesIds : [],
      subCategoriesIds: doc.SubCategoriesIds?.length
        ? doc.SubCategoriesIds
        : [],
      postCategoriesIds: doc.PostCategoriesIds?.length
        ? doc.PostCategoriesIds
        : [],
      CreatedDate: doc.dateRange?.createdDate
        ? new Date(doc.dateRange.createdDate).toISOString()
        : null,
      startDate: doc.dateRange?.startDate
        ? new Date(doc.dateRange.startDate).toISOString()
        : null,

      endDate: doc.dateRange?.endDate
        ? new Date(doc.dateRange.endDate).toISOString()
        : null,
    };

    return await axios
      .post(`${API_URL}dashboard/document/filter`, requestBody)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching documents:", error);
        throw error;
      });
  }

  async getDocumetChilde(data) {
    console.log("getDocumetChilde data:", data);
    const requestBody = {
      documentId: data.documentId || 0,
      parentId: data.parentId || 0,

      language: i18n.global.locale || "AL",
    };

    return await axios
      .post(`${API_URL}dashboard/document/filter/child`, requestBody)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching document children:", error);
        throw error;
      });
  }

  async getYears(data) {
    const webPage = getWebPagesId();
    const requestBody = {
      prokuroriaId: webPage || data.prokuroriaId || null,
      documentTypeId: data.documentTypeId || 0,
      language: i18n.global.locale || "AL",
    };

    return await axios
      .post(`${API_URL}dashboard/document/years`, requestBody)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching years:", error);
        throw error;
      });
  }
}

export default new DocumentService();
